module.exports = __webpack_public_path__ + "img/UpdateInstructions.a220f5d9.png";